import React, { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import { useParams, useNavigate } from 'react-router-dom';

const CampaignDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [campaign, setCampaign] = useState(null);
  const [leads, setLeads] = useState([]);
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, [id]);

  const fetchData = async () => {
    try {
      // Récupérer la campagne
      const { data: campaignData } = await supabase
        .from('campaigns')
        .select('*')
        .eq('id', id)
        .single();
      
      setCampaign(campaignData);

      // Récupérer les leads
      const { data: leadsData } = await supabase
        .from('campaign_leads')
        .select('lead_id')
        .eq('campaign_id', id);
      
      if (leadsData && leadsData.length > 0) {
        const leadIds = leadsData.map(l => l.lead_id);
        const { data: leadsDetails } = await supabase
          .from('leads')
          .select('*')
          .in('id', leadIds);
        setLeads(leadsDetails || []);
      }

      // Récupérer les agents
      const { data: agentLinks } = await supabase
        .from('campaign_agents')
        .select('agent_id')
        .eq('campaign_id', id);
      
      if (agentLinks && agentLinks.length > 0) {
        const agentIds = agentLinks.map(a => a.agent_id);
        const { data: agentsDetails } = await supabase
          .from('profiles')
          .select('id, email, full_name')
          .in('id', agentIds);
        setAgents(agentsDetails || []);
      }
    } catch (error) {
      console.error('Erreur:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div style={{ padding: '2rem' }}>Chargement...</div>;
  }

  if (!campaign) {
    return <div>Campagne non trouvée</div>;
  }

  return (
    <div style={{ padding: '2rem', backgroundColor: '#f3f4f6', minHeight: '100vh' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <button
          onClick={() => navigate('/campaigns')}
          style={{ marginBottom: '1rem', color: '#2563eb', background: 'none', border: 'none', cursor: 'pointer' }}
        >
          ← Retour
        </button>

        <h1 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '0.5rem' }}>{campaign.name}</h1>
        <p style={{ color: '#4b5563', marginBottom: '1rem' }}>{campaign.description}</p>

        <div style={{ marginBottom: '2rem' }}>
          <button
            onClick={() => navigate(`/campaigns/${id}/files`)}
            style={{ backgroundColor: '#2563eb', color: 'white', border: 'none', padding: '0.75rem 1.5rem', borderRadius: '0.5rem', cursor: 'pointer' }}
          >
            📁 Gérer les fichiers
          </button>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
          <div style={{ backgroundColor: 'white', padding: '1.5rem', borderRadius: '0.5rem' }}>
            <h3 style={{ marginBottom: '1rem' }}>Agents assignés ({agents.length})</h3>
            {agents.map(agent => (
              <div key={agent.id} style={{ padding: '0.5rem 0', borderBottom: '1px solid #e5e7eb' }}>
                {agent.full_name || agent.email}
              </div>
            ))}
          </div>
          <div style={{ backgroundColor: 'white', padding: '1.5rem', borderRadius: '0.5rem' }}>
            <h3 style={{ marginBottom: '1rem' }}>Leads ({leads.length})</h3>
            {leads.map(lead => (
              <div key={lead.id} style={{ padding: '0.5rem 0', borderBottom: '1px solid #e5e7eb' }}>
                {lead.first_name} {lead.last_name} - {lead.email}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CampaignDetailPage;
